import Badge from 'react-bootstrap/Badge';
import PropTypes from 'prop-types';
import React from 'react';
import { getStepNumberForBomOptions } from '../../../../bom/selectors';
import styles from './StepNumber.scss';
import { useSelector } from 'react-redux';

const StepNumber = ({ step }) => {
  const stepNumber = useSelector((state) => getStepNumberForBomOptions(state, step));

  return (
    <Badge bg="info" className={styles['step-number']}>
      {stepNumber}
    </Badge>
  );
};

StepNumber.propTypes = {
  step: PropTypes.string.isRequired,
};

export default StepNumber;
